import { Input } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  .ant-input-affix-wrapper {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  &&& .ant-input {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  .ant-input-group-addon {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
`;
